import React from 'react'
import {BoxLink} from '../../common/router_links/BoxLink'
import {OrganisationBox} from '../../common/types/organisation'
import {resolveBoxDisplayName} from '../../common/utils/resolveBoxDisplayName'
import {SortablePaginatedTable} from '../../webui/table/sortable-paginated-table/SortablePaginatedTable'
import {TableHeadCell} from '../../webui/table/sortable-paginated-table/TableHeadCell'
import {Box} from '../../webui/Box'
import {Typography} from '../../webui/Typography'
import {BoxColor} from '../../common/types/box'
import {contractTypeLabel} from '../../common/domain/contractType'

interface Props {
  boxes: OrganisationBox[]
}

const INITIAL_ROWS_PER_PAGE = 20

export interface BoxData {
  id: string
  name: string
  contractType: OrganisationBox['contractType']
  color?: BoxColor
}

const boxTableHeadCells: TableHeadCell<BoxData>[] = [
  {
    id: 'name',
    label: 'Name',
    render: (row) => <BoxLink boxId={row.id} linkText={row.name} />,
  },
  {
    id: 'contractType',
    label: 'Contract type',
    render: (row) => <Box>{contractTypeLabel(row.contractType ?? null)}</Box>,
  },
  {
    id: 'color',
    label: 'Color',
    render: (row) => {
      if (!row.color) return <Box>—</Box>

      return (
        <Box display="flex" alignItems="center">
          <Box bgcolor={row.color} height={16} width={16} borderRadius={4} mr={1} />
          <Typography variant="body2">{'(' + row.color + ')'}</Typography>
        </Box>
      )
    },
  },
]

const createBoxData = (box: OrganisationBox): BoxData => ({
  id: box.id,
  name: resolveBoxDisplayName(box),
  contractType: box.contractType ?? null,
  color: box.color,
})

export const OrganisationBoxesTable: React.FC<Props> = ({boxes}) => {
  return (
    <SortablePaginatedTable
      initialOrderByKey={'name'}
      initialRowsPerPage={INITIAL_ROWS_PER_PAGE}
      rows={boxes.map(createBoxData)}
      tableHeadCells={boxTableHeadCells}
      title={'Boxes in organisation'}
    />
  )
}
